export default __webpack_public_path__ + "static/media/refresh.34b2c0cc.svg";